export const webRtcIceServerUrl = 'stun:abc-test.drizt.dedyn.io:3478';
